import React, { useState } from 'react'
import AnimationSpinner from '../../AnimationSpinner'
import { Link, useNavigate } from 'react-router-dom'

const AIStocks = () => {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const cards = [
        { name: "Images", icon: "https://img.freepik.com/free-psd/3d-rendering-ui-icon_23-2149182289.jpg?t=st=1747044020~exp=1747047620~hmac=5e865277268395bfe1e7be7a42c5c15f5443c2eda6ffc1cdb19a16bf2ab65f0a&w=740", type: "images" },
        { name: "Videos", icon: "https://img.freepik.com/free-psd/3d-rendering-social-media-marketing-icon_23-2151185453.jpg?t=st=1747041986~exp=1747045586~hmac=a635489047f244b4b3627efed514cc61fc9b5a8c2fbe441ca0bda77a3fea654d&w=740", type: "videos" },
        { name: "GIFs", icon: "https://img.freepik.com/free-photo/3d-render-blue-gift-box-with-gold-ribbon-package_107791-17996.jpg?t=st=1747041766~exp=1747045366~hmac=bbb614f991b78ae078ca345938261707c192050445b3eab74c7fabe1ca24145b&w=740", type: "gifs" },
        { name: "Audios", icon: "https://img.freepik.com/free-psd/isolated-3d-render-music-web-ui-page-icon_47987-7568.jpg?t=st=1747041455~exp=1747045055~hmac=b5956614de47bd50fa97b85e58fa7023f6229774080bd684d2d2aa451ae4867a&w=740", type: "audios" }
    ]

    const handleCardClick = (type) => {
        console.log("Selected type:", type)
        navigate(`/ai-stock/${type}`)
    }

    return (
        <div className="right-container">
            <AnimationSpinner show={loading} />
            <div className="container h-75">
                <div className='p-2 border-bottom dashed mb-3'>
                    <h3>AI Stock</h3>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            {/* Content type options shown as boxes */}
                            <div id="contentOptions" className="card-body p-4">
                                <div className="row g-4">
                                    {cards.map((card, index) => (
                                        <div key={index} className="col-md-6 col-lg-3 col-sm-6">
                                            <div  className="card ai-stock-wrap ">
                                                <div className="card-body ai-stock-card text-center">
                                                    <div className="ai-stock-icon-box mb-3">
                                                        <img src={card.icon} alt={card.name} className="img-fluid" />
                                                    </div>
                                                    <div className='d-flex gap-2 justify-content-between align-items-center mt-4'>
                                                        <h5 className="card-title ai-stock-card-title mb-0">{card.name}</h5>
                                                        <button
                                                            onClick={() => handleCardClick(card.type)}
                                                            className="btn btn-primary ai-stock-button">
                                                            Choose
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AIStocks
